import { jewlrTheme } from "@jewlr/storybook/themes"

import baseColors from "../base-colors"

const colors = {
  ...jewlrTheme.colors,
  ...baseColors,
  primary: "#143057",
  secondary: "#f7e4c0",
}

export default colors
